import {Component} from './component';

window.hideFunctions = {
    expandDocMenu() {
        const container = document.querySelector('.sidebar-page-nav');
        if (!container) return;

        container.querySelectorAll('[hide-name]').forEach(a => {
            if (a.classList.contains('hide')) {
                const name = a.getAttribute('hide-name');
                const button = container.querySelector(`[hide-for="${name}"]`);
                if (button) button.click();
            }
        });
    },

    minimiseDocMenu() {
        const container = document.querySelector('.sidebar-page-nav');
        if (!container) return;

        container.querySelectorAll('[hide-name]').forEach(a => {
            if (!a.classList.contains('hide')) {
                const name = a.getAttribute('hide-name');
                const button = container.querySelector(`[hide-for="${name}"]`);
                if (button) button.click();
            }
        });
    },
};

export class Hider extends Component {

    setup() {
        this.container = this.$el;
        this.hideForId = this.container.getAttribute('hide-for');
        this.hideGroupId = this.container.getAttribute('for-accordion-group');
        this.hideFn = this.container.getAttribute('hide-fn');

        this.container.addEventListener('click', event => {
            if (this.shouldIgnoreEvent(event)) return;
            if (this.hideGroupId !== null) this.toggleGroup();
            else if (this.hideForId !== null) this.toggle();
            else if (this.hideFn) {
                const fn = window.hideFunctions[this.hideFn];
                if (fn) fn(this);
            }
        });

        this.container.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            if (this.shouldIgnoreEvent(event)) return;

            event.preventDefault();

            if (this.hideGroupId !== null) this.toggleGroup();
            else if (this.hideForId !== null) this.toggle();
            else if (this.hideFn) {
                const fn = window.hideFunctions[this.hideFn];
                if (fn) fn(this);
            }
        });
    }

    shouldIgnoreEvent(event) {
        const ignoreSelector = this.container.getAttribute('hide-ignore-children');
        if (!ignoreSelector) return false;

        const interactiveChild = event.target.closest(ignoreSelector);
        return interactiveChild !== null && interactiveChild !== this.container;
    }

    toggle() {
        const hideEls = document.querySelectorAll(`[hide-name="${this.hideForId}"]`);

        for (let i = 0; i < hideEls.length; i++) {
            const hasHideClassAttr = hideEls[i].getAttribute('hide-class');
            if (hasHideClassAttr) {
                hasHideClassAttr.split(' ').filter(Boolean).forEach(c => hideEls[i].classList.toggle(c));
            } else {
                hideEls[i].classList.toggle('hide');
            }
        }

        if (this.hideForId === 'search-box' && hideEls.length > 0) {
            const input = hideEls[0].querySelector('input');
            if (input) input.focus();
        }

        this.syncExpandedState();
    }

    hide() {
        const hideEls = document.querySelectorAll(`[hide-name="${this.hideForId}"]`);
        for (let i = 0; i < hideEls.length; i++) {
            const hasHideClassAttr = hideEls[i].getAttribute('hide-class');
            if (hasHideClassAttr) {
                hasHideClassAttr.split(' ').filter(Boolean).forEach(c => hideEls[i].classList.add(c));
            } else {
                hideEls[i].classList.add('hide');
            }
        }

        this.syncExpandedState();
    }

    toggleGroup() {
        const otherHiderEls = document.querySelectorAll(`[for-accordion-group="${this.hideGroupId}"]`);
        for (const el of otherHiderEls) {
            if (el === this.container) continue;

            const otherHideForId = el.getAttribute('hide-for');
            if (otherHideForId) {
                const hideEls = document.querySelectorAll(`[hide-name="${otherHideForId}"]`);
                for (const hideEl of hideEls) {
                    const hasHideClassAttr = hideEl.getAttribute('hide-class');
                    if (hasHideClassAttr) {
                        hasHideClassAttr.split(' ').filter(Boolean).forEach(c => hideEl.classList.add(c));
                    } else {
                        hideEl.classList.add('hide');
                    }
                }

                const otherTriggers = document.querySelectorAll(`[hide-for="${otherHideForId}"]`);
                for (const trigger of otherTriggers) {
                    trigger.setAttribute('aria-expanded', 'false');
                }
            }
        }
        this.toggle();
    }

    syncExpandedState() {
        if (!this.hideForId) return;

        const hideEls = document.querySelectorAll(`[hide-name="${this.hideForId}"]`);
        if (hideEls.length === 0) return;

        let isExpanded = false;
        for (let i = 0; i < hideEls.length; i++) {
            const hideClassAttr = hideEls[i].getAttribute('hide-class');
            if (hideClassAttr) {
                const classNames = hideClassAttr.split(' ').filter(Boolean);
                const hasHidden = classNames.every(c => hideEls[i].classList.contains(c));
                if (!hasHidden) {
                    isExpanded = true;
                    break;
                }
            } else if (!hideEls[i].classList.contains('hide')) {
                isExpanded = true;
                break;
            }
        }

        const triggers = document.querySelectorAll(`[hide-for="${this.hideForId}"]`);
        for (let j = 0; j < triggers.length; j++) {
            triggers[j].setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }

        for (let i = 0; i < hideEls.length; i++) {
            if (hideEls[i].classList.contains('comp-section')) {
                const isMinimised = hideEls[i].classList.contains('-is-minimised');
                const toggle = hideEls[i].querySelector('[data-section-toggle]');
                if (toggle) {
                    toggle.setAttribute('aria-expanded', isMinimised ? 'false' : 'true');
                }
            }
        }
    }

}
